import React from 'react';
import { useTranslation } from 'react-i18next';
import { AddForm } from './AddForm';
import { ContactInfo } from './ContactInfo';
import NotificationModal from '../../modals/notification_modal/ui/Main';

export function AdFormUI(
    handleImagesChange,
    handleVideoLinkChange,
    handleAnnouncementInputChange,
    isSubmitted,
    customTags,
    handleCustomTagsChange,
    handleAddTag,
    handleRemoveTag,
    tagsArray,
    handleSelectCategory,
    handleDescriptionChange,
    priceType,
    setPriceType,
    price,
    setPrice,
    handleVolumeChange,
    handlePublish,
    isLoading,
    handlePreview,
    userData,
    additionalPhones,
    phoneErrors,
    handlePhoneChange,
    handleDeletePhone,
    handleAddPhone,
    selectedLocation,
    UserLocations,
    handleSelectLocation,
    showErrorModal,
    setShowErrorModal,
    errorMessage,
    notificationTitle,
    notificationType,
    selectedSubcategory,
    volumeUnit,
    announcementName,
    description,
    aiSuggestions,
    handleSuggestionClick,
    handleAIGenerate,
    handleUpdateSuggestions,
    onSuccessCallback,
    activeTab,
    setActiveTab,
    selectedCategory,
    jsonData,
    setJsonData,
    isDealer,
    dealerRole,
    stockQuantity,
    setStockQuantity,
    minOrderQuantity,
    setMinOrderQuantity,
    minOrderPrice,
    setMinOrderPrice,
    canDeliver,
    setCanDeliver,
    deliveryCity,
    setDeliveryCity,
    deliveryDays,
    setDeliveryDays,
    deliveryTime,
    setDeliveryTime,
    deliveryVolume,
    setDeliveryVolume,
    deliveryDuration,
    setDeliveryDuration,
    toggleDeliveryDay,
    weekDays
) {
    const { t } = useTranslation();
    return (
        <div className="min-h-screen bg-gray-50/50">
            {/* Container - Header style matching */}
            <div className="px-4 md:px-[60px] lg:px-[120px] xl:px-[200px] py-6 lg:py-8">
                <div className="max-w-[1200px] mx-auto">
                    {/* Page Title */}
                    <div className="mb-8">
                        <h1 className="text-2xl lg:text-3xl font-bold text-[#147F26]">
                            {activeTab === 'dealer' ? t('createDealerAd') : t('createAnnouncement')}
                        </h1>
                        <p className="text-[#7AB30E] mt-2 text-sm lg:text-base">
                            {t('fillProductInfo')}
                        </p>
                    </div>

                    {/* Tabs */}
                    <div className="flex flex-wrap gap-2 mb-6 bg-white p-1.5 rounded-xl border border-gray-200 w-fit">
                        <TabButton
                            active={activeTab === 'advertisement'}
                            onClick={() => setActiveTab('advertisement')}
                            label={t('regularAd')}
                        />
                        <TabButton
                            active={activeTab === 'demand'}
                            onClick={() => setActiveTab('demand')}
                            label={t('demand')}
                        />
                        <TabButton
                            active={activeTab === 'bulk'}
                            onClick={() => setActiveTab('bulk')}
                            label={t('bulkUpload')}
                        />
                        {isDealer && (dealerRole === 'director' || dealerRole === 'manager') && (
                            <TabButton
                                active={activeTab === 'dealer'}
                                onClick={() => setActiveTab('dealer')}
                                label={t('dealer')}
                                accent
                            />
                        )}
                    </div>

                    {/* Main Content Grid */}
                    <div className="grid grid-cols-1 lg:grid-cols-3 gap-6">
                        {/* Left Column - Form */}
                        <div className="lg:col-span-2 space-y-6">
                            {AddForm(
                                handleImagesChange,
                                handleVideoLinkChange,
                                handleAnnouncementInputChange,
                                isSubmitted,
                                customTags,
                                handleCustomTagsChange,
                                handleAddTag,
                                handleRemoveTag,
                                tagsArray,
                                handleSelectCategory,
                                handleDescriptionChange,
                                priceType,
                                setPriceType,
                                price,
                                setPrice,
                                handleVolumeChange,
                                handlePublish,
                                isLoading,
                                handlePreview,
                                selectedSubcategory,
                                volumeUnit,
                                announcementName,
                                description,
                                aiSuggestions,
                                handleSuggestionClick,
                                handleAIGenerate,
                                handleUpdateSuggestions,
                                activeTab,
                                setActiveTab,
                                selectedCategory,
                                jsonData,
                                setJsonData,
                                isDealer,
                                dealerRole,
                                stockQuantity,
                                setStockQuantity,
                                minOrderQuantity,
                                setMinOrderQuantity,
                                minOrderPrice,
                                setMinOrderPrice,
                                canDeliver,
                                setCanDeliver,
                                deliveryCity,
                                setDeliveryCity,
                                deliveryDays,
                                setDeliveryDays,
                                deliveryTime,
                                setDeliveryTime,
                                deliveryVolume,
                                setDeliveryVolume,
                                deliveryDuration,
                                setDeliveryDuration,
                                toggleDeliveryDay,
                                weekDays
                            )}
                        </div>

                        {/* Right Column - Contact Info */}
                        <div className="lg:col-span-1">
                            <div className="sticky top-6">
                                <ContactInfo
                                    userData={userData || {}}
                                    additionalPhones={additionalPhones}
                                    phoneErrors={phoneErrors}
                                    handlePhoneChange={handlePhoneChange}
                                    handleDeletePhone={handleDeletePhone}
                                    handleAddPhone={handleAddPhone}
                                    UserLocations={UserLocations}
                                    selectedLocation={selectedLocation}
                                    handleSelectLocation={handleSelectLocation}
                                    isSubmitted={isSubmitted}
                                />
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            {/* Notification Modal */}
            <NotificationModal
                show={showErrorModal}
                onClose={() => {
                    setShowErrorModal(false);
                    onSuccessCallback?.();
                }}
                title={notificationTitle}
                message={errorMessage}
                type={notificationType || 'warning'}
            />
        </div>
    );
}

function TabButton({ active, onClick, label, accent }) {
    return (
        <button
            onClick={onClick}
            className={`
                px-4 py-2.5 rounded-lg text-sm font-medium transition-all duration-200
                ${active
                    ? 'bg-[#147F26] text-white shadow-sm shadow-[#147F26]/25'
                    : 'text-[#147F26] hover:bg-[#147F26]/10 border border-[#147F26]/30'
                }
            `}
        >
            {label}
        </button>
    );
}
